import { useCallback, useState } from "react";
import type { GameHistoryNoteResponse } from "libs/apiClient";
import { usePendingFilesList } from "./gameHistoryPendingFiles";

export function useGameHistoryNoteEdit() {
	const [editingNoteId, setEditingNoteId] = useState<number | null>(null);
	const [editText, setEditText] = useState("");
	const [editDeletedFileIds, setEditDeletedFileIds] = useState<number[]>([]);
	const editNewFiles = usePendingFilesList();

	const startEdit = useCallback(
		(note: GameHistoryNoteResponse) => {
			setEditingNoteId(note.id);
			setEditText(note.note ?? "");
			editNewFiles.clear();
			setEditDeletedFileIds([]);
		},
		[editNewFiles],
	);

	const reset = useCallback(() => {
		setEditingNoteId(null);
		setEditText("");
		editNewFiles.clear();
		setEditDeletedFileIds([]);
	}, [editNewFiles]);

	const removeExistingFile = useCallback((fileId: number) => {
		setEditDeletedFileIds((prev) => [...prev, fileId]);
	}, []);

	return {
		editingNoteId,
		editText,
		setEditText,
		editDeletedFileIds,
		editNewFiles,
		startEdit,
		reset,
		removeExistingFile,
	};
}
